export const titleKeyMap: Record<string, string> = {
  "首页": "HomePage",
  "数据中心": "Data Center",
  "客户": "Customer",
  "客户看板": "Customer Dashboard",
  "会员数据": "Member data",
  "客户管理": "Customer Management",
  "客户列表": "Customer List",
  "合作资源": "Cooperation Resource",
  "云客户": "Cloud Customer",
  "我的": "My",
  "合作租户": "Cooperation Tenant",
  "供应商": "Supplier",
  "供应商看板": "Supplier Dashboard",
  "供应商列表": "Supplier List",
  "子会员列表": "Sub-member List",
  "供应商等级": "Supplier Level",
  "面板书": "Panel Book",
  "生成面板书": "Generate Panel Book",
  "项目": "Project",
  "项目管理": "Project Management",
  "项目列表": "Project List",
  "混合API": "Hybrid API",
  "项目结算": "Project Settlement",
  "项目调度": "Project Scheduling",
  "会员调度": "Member Scheduling",
  "记录": "Record",
  "记录管理": "Record Management",
  "参与记录": "Participation Record",
  "会员终止日志": "Member Termination Record",
  "调查记录": "Survey Record",
  "操作日志": "Operation Log",
  "终止记录": "Termination Record",
  "回调记录": "Callback Record",
  "登录日志": "Login Log",
  "财务": "Finance",
  "财务管理": "Financial Management",
  "供应商财务日志": "Supplier Financial Log",
  "员工财务日志": "Employee Financial Log",
  "供应商账单": "Supplier Bill",
  "供应商结算": "Supplier Settlement",
  "员工结算": "Employee Settlement",
  "部门提成": "Department Commission",
  "客户发票": "Customer Invoice",
  "辅助": "Auxiliary",
  "辅助功能": "Auxiliary Function",
  "文章公告": "Article Announcement",
  "发送消息": "Send Message",
  "通知中心": "Notification Center",
  "IP查询": "IP Query",
  "UID分拣": "UID Sorting",
  "UID解析": "UID Parsing",
  "链路解析": "Link Parsing",
  "组织": "Organization",
  "组织架构": "Organizational Structure",
  "员工管理": "Employee Management",
  "部门管理": "Department Management",
  "角色管理": "Role Management",
  "提成规则": "Commission Rules",
  "调查站": "Survey Site",
  "数据看板": "Data Board",
  "数据分析": "Data Analysis",
  "调查系统": "Survey System",
  "仪表盘": "Dashboard",
  "IR查询": "IR Query",
  "站点设置": "Site Settings",
  "会员管理": "Member Management",
  "会员组": "Member Group",
  "会员等级": "Level Management",
  "会员财务日志": "Member Financial Log",
  "会员账单": "Member Bill",
  "员工账单": "Employee Bill",
  "财务日志": "Financial Log",
  "账单管理": "Bill Management",
  "会员": "Member",
  "管理": "Management",
  "配置": "Configuration",
  "配置管理": "Configuration Management",
  "系统设置": "System Settings",
  "数据字典": "Data Dictionary",
  "前置问卷库": "Pre-questionnaire Library",
  "站点模板": "Site Templates",
  "三方配置": "Third-party Configuration",
  "短信配置": "SMS Configuration",
  "邮箱配置": "Email Configuration",
  "事件通知": "Event Notification",
  "等级管理": "Grade Management",
  "安检配置": "Security Inspection Configuration",
  "高级配置": "Advanced Configuration",
};

// 导出类型定义，方便其他地方使用
export type TitleKeyMapType = typeof titleKeyMap;

// 英文映射中文
export const titleenKeyMap: Record<string, string> = {
  'HomePage': '首页',
  'Data Center': '数据中心',
  'Customer': '客户',
  'Customer Dashboard': '客户看板',
  'Member data': '会员数据',
  'Customer Management': '客户管理',
  'Customer List': '客户列表',
  'Cooperation Resource': '合作资源',
  'Cloud Customer': '云客户',
  'My': '我的',
  'Cooperation Tenant': '合作租户',
  'Supplier': '供应商',
  'Supplier Dashboard': '供应商看板',
  'Supplier List': '供应商列表',
  'Sub-member List': '子会员列表',
  'Supplier Level': '供应商等级',
  'Panel Book': '面板书',
  'Generate Panel Book': '生成面板书',
  'Project': '项目',
  'Project Management': '项目管理',
  'Project List': '项目列表',
  'Hybrid API': '混合API',
  'Project Settlement': '项目结算',
  'Project Scheduling': '项目调度',
  'Member Scheduling': '会员调度',
  'Record': '记录',
  'Record Management': '记录管理',
  'Participation Record': '参与记录',
  'Member Termination Record': '会员终止日志',
  'Survey Record': '调查记录',
  'Operation Log': '操作日志',
  'Termination Record': '终止记录',
  'Callback Record': '回调记录',
  'Login Log': '登录日志',
  'Finance': '财务',
  'Financial Management': '财务管理',
  'Supplier Financial Log': '供应商财务日志',
  'Employee Financial Log': '员工财务日志',
  'Supplier Bill': '供应商账单',
  'Supplier Settlement': '供应商结算',
  'Employee Settlement': '员工结算',
  'Department Commission': '部门提成',
  'Customer Invoice': '客户发票',
  'Auxiliary': '辅助',
  'Auxiliary Function': '辅助功能',
  'Send Message': '发送消息',
  'Article Announcement': '文章公告',
  'Notification Center': '通知中心',
  'IP Query': 'IP查询',
  'UID Sorting': 'UID分拣',
  'UID Parsing': 'UID解析',
  'Link Parsing': '链接解析',
  'Organization': '组织',
  'Organizational Structure': '组织架构',
  'Employee Management': '员工管理',
  'Department Management': '部门管理',
  'Role Management': '角色管理',
  'Commission Rules': '提成规则',
  'Survey Site': '调查站',
  'Data Board': '数据看板',
  'Data Analysis': '数据分析',
  'Survey System': '调查系统',
  'Dashboard': '仪表盘',
  'IR Query': 'IR查询',
  'Site Settings': '站点设置',
  'Member Management': '会员管理',
  'Member Group': '会员组',
  'Level Management': '会员等级',
  'Member Financial Log': '会员财务日志',
  'Member Bill': '会员账单',
  'Employee Bill': '员工账单',
  'Financial Log': '财务日志',
  'Bill Management': '账单管理',
  'Member': '会员',
  'Management': '管理',
  'Configuration': '配置',
  'Configuration Management': '配置管理',
  'System Settings': '系统设置',
  'Data Dictionary': '数据字典',
  'Pre-questionnaire Library': '前置问卷库',
  'Site Templates': '站点模板',
  'Third-party Configuration': '三方配置',
  'SMS Configuration': '短信配置',
  'Email Configuration': '邮件配置',
  'Event Notification': '事件通知',
  'Grade Management': '等级管理',
  'Security Inspection Configuration': '安检配置',
  'Advanced Configuration': '高级配置',
}
